/* global axios */
import AsteriskApiClient from './index';

class QueuesAPI extends AsteriskApiClient {
  constructor() {
    super('queues');
  }

  // GET /api/v1/accounts/:account_id/asterisk_aci/queues
  get() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:account_id/asterisk_aci/queues/:queue
  show(queue) {
    return axios.get(`${this.url}/${encodeURIComponent(queue)}`);
  }

  // POST /api/v1/accounts/:account_id/asterisk_aci/queues
  create(data) {
    return axios.post(this.url, { queue: data });
  }

  // PUT /api/v1/accounts/:account_id/asterisk_aci/queues/:queue
  update(queueName, data) {
    return axios.put(`${this.url}/${encodeURIComponent(queueName)}`, { queue: data });
  }

  // DELETE /api/v1/accounts/:account_id/asterisk_aci/queues/:queue
  delete(queue) {
    return axios.delete(`${this.url}/${encodeURIComponent(queue)}`);
  }

  // POST /api/v1/accounts/:account_id/asterisk_aci/queues/:queue/add_member
  addMember(queue, extension, penalty) {
    return axios.post(`${this.url}/${encodeURIComponent(queue)}/add_member`, {
      extension,
      penalty,
    });
  }

  // POST /api/v1/accounts/:account_id/asterisk_aci/queues/:queue/remove_member
  removeMember(queue, extension) {
    return axios.post(`${this.url}/${encodeURIComponent(queue)}/remove_member`, { extension });
  }

  // POST /api/v1/accounts/:account_id/asterisk_aci/queues/:queue/pause_member
  pauseMember(queue, extension, reason = '') {
    return axios.post(`${this.url}/${encodeURIComponent(queue)}/pause_member`, { extension, reason });
  }

  // POST /api/v1/accounts/:account_id/asterisk_aci/queues/:queue/unpause_member
  unpauseMember(queue, extension) {
    return axios.post(`${this.url}/${encodeURIComponent(queue)}/unpause_member`, { extension });
  }
}

export default new QueuesAPI();
